<template>
  <div class="container">
    <h4 class="ref">
      <b v-if="tab.Name">
        <b v-if="isQuote">REF : </b>
        {{ tab.Name.toUpperCase() }}
        <button v-if="isQuote" @click="sendEmail" class="send-email lyt-soft-btn">
          <font-awesome-icon icon="fa-solid fa-3x fa-paper-plane"/>
        </button>
      </b>
    </h4>

    <h4 class="ref" v-if="isQuote"><b v-if="tab.Name">
      <b>Quote No. : {{ tab.saleNumber }}</b></b>
    </h4>
    <div class="content">
      <div class="lines" v-for="item in tab.items">
        <div class="line-descr">
          <h6>{{ $utils.toPascalCase($utils.cutLength(item.Description, 30)) }}</h6>
        </div>

        <div class="row" v-if="item.instructions">
          <ul class="cooking-instruction-list">
            <li class="cooking-instruction-list-item" v-for="instruction in item.instructions">
              {{ instruction.CookingMsg }} <span>{{ instruction.count }} X {{
                $utils.formatMoney(instruction.Price)
              }}</span>
              Total: {{ $utils.formatMoney(instruction.count * instruction.Price) }}
            </li>
          </ul>
        </div>
        <div class="row">
          <!-- formatQTY normalises to 4 dp and trims trailing zeros, so the
               value shown for a held table matches the precision at which
               it was saved. -->
          <b class="col-7  sum-line">{{ $utils.formatQTY(item.Qty) }} * {{ $utils.formatMoney(item.Unit) }}</b>
          <div class="col-5 total">{{ $utils.formatMoney(itemTabTotal(item.id)) }}</div>
        </div>
        <br>
      </div>
    </div>
    <div class="btm-crd">
      <button class="payment-button opn-tbl" @click="downloadTable">
        <font-awesome-icon icon="fa-solid fa-download"/>
        Download
      </button>

      <button class="payment-button opn-tbl" @click="checkSales" v-if="!isHistory">
        <font-awesome-icon icon="fa-solid fa-pen-to-square"/>
        Edit Order
      </button>

      <button class="payment-button void-tbl w-40" @click="voidTable" v-if="!isHistory">
        <font-awesome-icon icon="fa-solid fa-trash"/>
        Delete
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "TableDetails",
  props: {
    tab: {type: Object, required: true},
    isHistory: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isQuote() {
      return !!(this.tab.customer && this.tab.customer !== '');
    },
    loading(){
      return this.$store.getters.getLoadingState;
    },
  },
  methods: {
    itemTabTotal(id) {
      let sum = 0;
      let items = this.tab.items;
      if (!items) return 0.00;
      let item = items.find(item=>item.id === id);
      sum += item.Line;
      if (item.instructions) {
        for (let j = 0; j < item.instructions.length; j++) {
          let instruction = item.instructions[j];
          sum += (instruction.count * instruction.Price)
        }
      }
      return sum;
    },

    checkSales() {
      let sale = this.$store.getters.getSaleLines;
      if (sale.length > 0) {
        Swal.fire({
          title: 'Are you sure?',
          text: "Opening this table will override the current sale",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, Override it!'
        }).then((result) => {
          if (result.isConfirmed) {
            this.selectTab();
          }
        })
      } else {
        this.selectTab()
      }
    },
    selectTab() {
      this.$utils.showLoading()
      return this.$store.dispatch('getTableBySaleNumber', this.tab.saleNumber)
          .then(() => this.$router.push({name: 'pos'}))
          .finally(()=>this.$utils.hideLoading());
    },
    voidTable() {
      return Swal.fire({
        title: 'Are you sure?',
        text: "This step cannot be reversed!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, Void it!'
      }).then((result) => {
        if (result.isConfirmed) {
          this.$utils.showLoading()
          return this.$store.dispatch('removeTable', this.tab.saleNumber)
              .finally(() => {
                this.$utils.hideLoading()
                return this.$emit('click');
              })
        }
      })
    },

    downloadTable() {
      let quote = this.tab.saleNumber;
      if (this.isHistory){
        return this.$store.dispatch(`downloadInvoiceFromSale`,quote)
      }
      return this.$store.dispatch(`downloadQuote`, quote);
    },

    sendEmail() {
      return Swal.fire({
        title: 'Input Email Address',
        icon: 'question',
        input: 'email',
        showCancelButton: true,
        confirmButtonText: 'Send Email',
        showLoaderOnConfirm: true,
        preConfirm: (email) => {
          let data = {
            email: email,
            quote: this.tab.saleNumber
          };
          return this.$store.dispatch('emailQuote', data)
              .then(() => data)
              .catch(err => Swal.showValidationMessage(err))
        },
        allowOutsideClick: () => !Swal.isLoading()
      }).then((result) => {
        if (result.isConfirmed) {
          return Swal.fire({
            title: `Success`,
            icon: 'success',
            text: `Quote ${result.value.quote} Sent to ${result.value.email}`
          })
        }
      })
    }
  },
}
</script>

<style lang="scss" scoped>
.btm-crd {
  position: absolute;
  bottom: -1px;
  left: 0;
  right: 0;
  width: 100%;
  height: 75px;
  -webkit-box-shadow: 0 -2px 8px 0 rgba(203, 153, 126, 0.4);
  box-shadow: 0 -2px 8px 0 rgba(203, 153, 126, 0.4);
  display: flex;
  gap: 10px;
  flex-direction: row;
  padding: 10px;
  z-index: 1;
  background: white;

  .opn-tbl {
    background: #1e88e5;
  }

  .void-tbl {
    background: red;
  }

  button {
    color: white;
    font-size: 15px;
    font-weight: 700;
    font-family: 'Inter', sans-serif;
    border-radius: 5px;
    height: 80%;
    width: 50%;
    max-width: 400px;
  }

  h6 {
    bottom: 0;
    margin: 0;
  }

  .sum-line {
    font-size: 0.8rem;
    font-weight: bolder;
  }

  .container {
    overflow-y: scroll;
  }
}

.ref {
  margin-bottom: 15px;
}

.send-email {
  color: white;
  font-size: 20px;
  height: 45px;
  width: 45px;
  border-radius: 10px;
  position: absolute;
  top: 27px;
  right: 9px;
  bottom: 0;
}

.content {
  overflow-y: scroll;
}

.cooking-instruction-list {
  list-style: inside;

  .cooking-instruction-list-item {
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;
    color: #404040;
    display: flex;
    justify-content: space-between;
  }
}
</style>
